class quickAddButton extends Controller {

  static targets = ['headerButton'];

  connect() {
    this.onScrollRunning = false;
  }

  // Expand the options when the button is clicked.
  expand(ev) {
    const body = document.body;

    ev.stopPropagation();
    if (!body.classList.contains('quick-add-active')) {
      body.classList.add('quick-add-active');
      // Close the quick add if they click anywhere else on the document.
      document.addEventListener('click', function(e){
        if ( e !== ev ) {
          body.classList.remove('quick-add-active');
        }
      });
    } else {
      body.classList.remove('quick-add-active');
    }
  }

  // Decide when to show the fixed button.
  onScroll() {
    // If we're scrolling, limit the amount of times the dom is repainted.
    if ( ! this.onScrollRunning ) {
      this.onScrollRunning = true;
      // If browser supports requestAnimationFrame
      if ( window.requestAnimationFrame ) {
        window.requestAnimationFrame(this.toggleFixedButton.bind(this));
      } else {
        setTimeout(this.toggleFixedButton.bind(this), 60);
      }
    }
  }

  toggleFixedButton() {
    const button = this.headerButtonTarget;

    // If scrolled past the "Quick Add" button, show the fixed one.
    if ( (button.offsetTop + button.offsetHeight) <= window.scrollY  ) {
      if ( ! document.body.classList.contains('quick-add-visible') ) {
        document.body.classList.add('quick-add-visible');
      }
    } else { // hide the fixed one, the "Quick Add" button is visible again.
      document.body.classList.remove('quick-add-visible');
      // If it's open, close it.
      document.body.classList.remove('quick-add-active');
    }

    this.onScrollRunning = false
  }

  openModal(e) {
    e.preventDefault();
    App.Form.openQuickAddModal(e.target);

    if ( document.body.classList.contains('quick-add-active') ) {
      document.body.classList.remove('quick-add-active');
    }
  }
};

export default quickAddButton;


// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/shared/quick-add-button-controller.js